const $elements = {
  followButton: document.querySelector('#followButtonInCompanyPage'),
  supporterList: document.querySelector('.supporterlist'),
  followCount: document.querySelector('.sup-title .__follower_count'),
  companyId: document.querySelector('#follow_company_id')
};

const componentMountSelectors = {
  followItem: '#js-supporter-img',
  followModal: '#js-modal-follow-company',
  shareModal: '#js-modal-share-company',
  loginModal: '#js-facebook-login-modal'
};

const $componentMountElements = {
  followItem: document.querySelector(componentMountSelectors.followItem),
  followModal: document.querySelector(componentMountSelectors.followModal),
  shareModal: document.querySelector(componentMountSelectors.shareModal),
  loginModal: document.querySelector(componentMountSelectors.loginModal)
};

export {
  $elements,
  componentMountSelectors,
  $componentMountElements
};
